import React, { createContext, useState } from "react"

export const StoreContext = createContext({})

const isBrowser = typeof window !== `undefined`
const cartKey = `cart`
export const StoreProvider = ({ children }) => {
  const localCart = isBrowser ? localStorage.getItem(cartKey) : null
  const [user, setUser] = useState(null)
  const [cart, setCart] = useState(localCart ? JSON.parse(localCart) : [])
  const [cartOpen, setCartOpen] = useState(false)

  const setCartItem = checkout => {
    if (isBrowser) {
      localStorage.setItem(cartKey, JSON.stringify(checkout))
    }

    setCart(checkout)
  }

  const addToCart = product => {
    const objIndex = cart.findIndex(obj => obj.id === product.id)
    if (objIndex >= 0) {
      var newCart = cart
      newCart[objIndex].qty = product.qty + newCart[objIndex].qty
      setCartItem([...newCart])
    } else {
      setCartItem([...cart, product])
    }
  }

  const updateQuantity = (index, qty) => {
    var newCart = cart
    const quantity = qty + newCart[index].qty
    if (quantity >= 1) {
      newCart[index].qty = qty + newCart[index].qty
      setCartItem([...newCart])
    } else {
      newCart.splice(index, 1)
      setCartItem([...newCart])
    }
  }
  const removeItem = index => {
    var newCart = cart
    newCart.splice(index, 1)
    setCartItem([...newCart])
  }

  const toggleCart = value => {
    setCartOpen(value)
  }
  const resetCart = () => {
    setCartItem([])
  }

  return (
    <StoreContext.Provider
      value={{
        user,
        setUser,
        setCartOpen,
        cart,
        addToCart,
        cartOpen,
        toggleCart,
        updateQuantity,
        removeItem,
        resetCart,
      }}
    >
      {children}
    </StoreContext.Provider>
  )
}
